import { useSelector } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/query';

import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import { getSelectedTask } from '../store/slices/document-review-slice';

import {
  useGetSuggestionsAutoCompleteDocsQuery,
  SuggestionsAutoCompleteFieldItem,
} from '../store/api-slices/suggestions-autocomplete-docs.endpoints';

export const useSuggestionsAutoCompleteDocs = () => {
  const country = useSelector(getCountry);
  const selectedTask = useSelector(getSelectedTask);
  const nid = selectedTask?.nid;
  const businessType = selectedTask?.business_type;

  // Hacer query para CO y MX
  const queryArg =
    !country || !nid ? skipToken : { country, nid, businessType };

  const result = useGetSuggestionsAutoCompleteDocsQuery(queryArg);
  const data = (result.data ?? []) as SuggestionsAutoCompleteFieldItem[];

  return { ...result, data, nid };
};
